import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import VideoPlayer from "../../Utils/Custom/VideoPlayer";
import { GapVM } from "../../Utils/Custom/VideoPlayer/models/gapVM";
import { VideoInfo } from "../../Utils/Custom/VideoPlayer/models/videoInfo";
import { getVideoPlayBackFromString } from "../../Utils/Models/devices";
interface Props {
  url: string;
}
export default function ShowPublicPlaylistVideo({ url }: Props) {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  const [serialNumber, setSerialNumber] = useState("");
  const [timezone, setTimezone] = useState("");
  const [videoInfo, setVideoInfo] = useState<VideoInfo | null>(null);

  const urlWasUpdated = () => {
    if (!url) {
      return;
    }
    const urlObj = new URL(url);
    const gaps = JSON.parse(urlObj.searchParams.get("gaps") || "[]") as GapVM[];
    const playbackModeString = urlObj.searchParams.get("playbackMode") ?? "";
    const serialNumber = urlObj.searchParams.get("serialNumber") ?? "";
    const timezone = urlObj.searchParams.get("timeZone") ?? "";
    const videoInfo: VideoInfo = {
      url: urlObj.searchParams.get("url") || "",
      playbackMode: getVideoPlayBackFromString(playbackModeString),
      startDateISO: urlObj.searchParams.get("startDate") || "",
      totalDurationSeconds: Number(urlObj.searchParams.get("videoDurationSeconds")),
      gaps,
    };
    setVideoInfo(videoInfo);
    setSerialNumber(serialNumber);
    setTimezone(timezone);
  };

  useEffect(urlWasUpdated, [url]);

  return (
    <Grid
      container
      justify="center"
      style={{ width: "100%" }}
      data-testid="show-public-playlist-video-player"
    >
      <Grid container justify="center">
        <img
          src={"/images/designed/anavio.svg"}
          alt="Anavio logo"
          style={{ objectFit: "cover", width: "15%", marginTop: "8px" }}
        />
      </Grid>
      <Button
        style={{ marginTop: "16px" }}
        variant="contained"
        color="primary"
        onClick={() => setShow(true)}
      >
        {t("OpenVideo")}
      </Button>
      <Grid item xs={12}>
        {show && videoInfo && (
          <VideoPlayer
            serialNumber={serialNumber}
            videoTitle={serialNumber}
            timezone={timezone}
            videoInfo={videoInfo}
            fatalErrorMessage=""
            isLoading={false}
            shouldDisplayShareButton={false}
            shouldDisplayDownloadButton={false}
            onClose={() => setShow(false)}
          />
        )}
      </Grid>
    </Grid>
  );
}
